import React from "react";
import { styled } from "../theme/stitches.config";
// import { Link } from 'react-router-dom'

export const ButtonLink = (props) => {
  const { text, size, href } = props;

  const ButtonLink = styled("a", {
    fontFamily: "$regular",
    fontSize: "$lg",
    background: "$button",
    width: "$button",
    height: "$buttonHeight",
    borderRadius: "$xs",
    maxWidth: "100%",
    padding: "20px 35px",
    // color: '$white',

    // hover
    "&:hover": {
      color: "$black",
    },

    variants: {
      size: {
        menu: {
          width: "$button",
          height: "$buttonMenuHeight",
          "&:hover": {
            background: "purple",
          },
        },

        header: {
          display: "flex",
          justifyContent: "center",
          height: "$buttonHeight",
          transition: "$button",
          // '&:hover': {
          //   background: 'transparent',
          //   color: '$orange',
          //   borderWidth: '$2',
          //   borderColor: '$orange',
          //   borderStyle: 'solid'
          // },
        },

        vantagens: {
          fontFamily: "$regular",
          width: "200px",
          height: "62px",
          transition: "$button",
          // '&:hover': {
          //   background: 'transparent',
          //   color: '$orange',
          //   borderWidth: '$2',
          //   borderColor: '$orange',
          //   borderStyle: 'solid'
          // },
        },

        navbar: {
          // fontFamily: '$bold',
          color: "black",
          fontSize: "$md",
          width: "$buttonWidth",
          height: "$buttonNavbarHeight",
          transition: "$button",
          padding: "0.7rem 2rem",
          // '&:hover': {
          //   background: 'transparent',
          //   color: '$orange',
          //   borderWidth: '$2',
          //   borderColor: '$orange',
          //   borderStyle: 'solid'
          // },
          "@mobile": {
            fontSize: "14px",
            width: "120px",
          },
        },
        planos: {
          // fontFamily: '$bold',
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "black",
          fontSize: "$md",
          maxWidth: "100%",
          height: "55px",
          transition: "$button",
          padding: "0.7rem 2rem",
          minWidth: "150px",
          // border: '3px solid red',
          // '&:hover': {
          //   background: 'transparent',
          //   color: '$orange',
          //   borderWidth: '$2',
          //   borderColor: '$orange',
          //   borderStyle: 'solid'
          // },
          "@mobile": {
            fontSize: "14px",
          },
        },

        "planos-lp": {
          // fontFamily: '$bold',
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "black",
          fontSize: "$md",
          maxWidth: "150px",
          height: "41px",
          transition: "$button",
          padding: "0.7rem 2rem",
          minWidth: "220px",
          margin: "0 auto",
          "@mobile": {
            fontSize: "14px",
          },
        },

        "planos-greys": {
          // fontFamily: '$bold',
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "black",
          fontSize: "$md",
          maxWidth: "150px",
          height: "55px",
          transition: "$button",
          padding: "0.7rem 2rem",
          minWidth: "220px",
          margin: "0 auto",
          "@mobile": {
            fontSize: "14px",
          },
        },

        blog: {
          // fontFamily: '$bold',
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "black",
          fontSize: "18px",
          // width: '160px',
          height: "46px",
          transition: "$button",
          padding: "0.7rem 2rem",
          margin: "12px 0px 12px 0px",
          background: "#23cf5c",
          // fontWeight: 'bold',
          // '&:hover': {
          //   background: 'transparent',
          //   color: '$orange',
          //   borderWidth: '$2',
          //   borderColor: '$orange',
          //   borderStyle: 'solid'
          // },
          "@mobile": {
            fontSize: "14px",
          },
        },
        hbo: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "black",
          fontSize: "$md",
          width: "$buttonWidth",
          height: "$buttonNavbarHeight",
          transition: "$button",
          padding: "0.7rem 2rem",
          "@mobile": {
            fontSize: "14px",
            padding: "0",
          },
          background: "#23cf5c",
        },
        rmkt: {
          color: "black",
          fontSize: "$md",
          width: "$buttonWidth",
          height: "$buttonNavbarHeight",
          transition: "$button",
          padding: "0.7rem 2rem",
          "@mobile": {
            fontSize: "14px",
            width: "144px",
            height: "38px",
          },
          background: "#23cf5c",
        },
        jackbet: {
          color: "black",
          fontSize: "18px",
          fontFamily: "$bold",
          width: "265px",
          height: "55px",
          transition: "$button",
          padding: "1rem 4.5rem",
          margin: "10px auto",
          "@mobile": {
            fontSize: "18px",
            width: "265px",
            height: "55px",
          },
        },
        "jackbet-steps": {
          color: "black",
          fontSize: "18px",
          fontFamily: "$bold",
          width: "265px",
          height: "55px",
          transition: "$button",
          padding: "1rem 4.5rem",
          margin: "-50px auto 10px",
          zIndex: "1",
          "@mobile": {
            fontSize: "18px",
            width: "265px",
            height: "55px",
          },
        },
        pv: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "#000000 !important",
          fontSize: "18px",
          width: "100%",
          height: "55px",
          transition: "$button",
          padding: "0.7rem 2rem",
          minWidth: "400px",
          "&:hover": {
            opacity: "0.8",
          },
          "@mobile": {
            fontSize: "14px",
          },
        },
      },
    },
  });

  return (
    <>
      <ButtonLink size={size} href={href}>
        {text}
      </ButtonLink>
    </>
  );
};
